export interface CspViolationPayload {
    effectiveDirective: string;
    blockedOrigin: string;
    documentPath: string;
}

interface ViolationLike {
    effectiveDirective: string;
    blockedURI: string;
    documentURI: string;
}

const WEB_PROTOCOLS = ['http:', 'https:', 'ws:', 'wss:'];

const toBlockedOrigin = (blockedURI: string): string => {
    try {
        const url = new URL(blockedURI);
        return WEB_PROTOCOLS.includes(url.protocol) ? url.origin : url.protocol.replace(':', '');
    } catch {
        // Not a URL: browsers report keywords such as "inline" and "eval".
        return blockedURI;
    }
};

const toDocumentPath = (documentURI: string): string => {
    try {
        return new URL(documentURI).pathname;
    } catch {
        return '';
    }
};

/** Keeps only what is needed to diagnose a violation; never full URLs, query strings or tokens. */
export const toCspViolationPayload = ({ effectiveDirective, blockedURI, documentURI }: ViolationLike): CspViolationPayload => ({
    effectiveDirective,
    blockedOrigin: toBlockedOrigin(blockedURI),
    documentPath: toDocumentPath(documentURI),
});

export const registerCspViolationReporter = (
    track: (name: string, properties: CspViolationPayload) => void,
    target: Pick<EventTarget, 'addEventListener'> = document
): void => {
    target.addEventListener('securitypolicyviolation', (event) => {
        track('csp.violation', toCspViolationPayload(event as SecurityPolicyViolationEvent));
    });
};
